<template>
  <div>
    <v-autocomplete
      :value="city"
      :items="filterCities"
      :label="$i18n.t(label)"
      @change="changedTo"
      :multiple="multiple"
      :loading="loading"
      ref="select"
      :clearable="clearable"
      :rules="rules"
      :dense="dense"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="multiple === false">
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
        <div v-else>
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
            <v-icon
              style="float: right; margin-left: 5px"
              small
              @click="remove(data.item)"
              >mdi-close</v-icon
            >
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple v-if="data && data.item">
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }} - {{ data.item.state }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";

@Component({
  name: "CitySelect",
  props: {
    value: {
      default: false,
    },
    country: {
      default: false,
    },
    state: {
      default: "",
    },
    label: {
      default: "City",
    },
    dense: {
      default: false,
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class CitySelect extends (Vue, Themeable) {
  city = null;
  cities = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.city = null;
    this.$emit("input", null);
    this.$emit("inputFull", null);
  }

  get filterCities() {
    if (this.cities == null || this.cities.length == 0) {
      return [];
    }
    let filterby = this.filter;
    const state = this.state;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "" && state == "") return this.cities;
    if (filterby == "") {
      const fc = this.cities.filter(function (c) {
        return state == c.state;
      });
      return fc;
    } else {
      const fc = this.cities.filter(function (c) {
        return (
          ((state == "" || state == c.state) &&
            c.state &&
            c.state.toString().indexOf(filterby) >= 0) ||
          c.name.toLowerCase().indexOf(filterby) >= 0
        );
      });
      if (filterby != null && filterby.length > 2) {
        if (fc.length == 0) {
          this.populateCities(filterby);
        }
      }
      return fc;
    }
  }

  async populateCities(filterby) {
    const response = await doGet(
      "/api/maputil/populateCitiesIndia?key=" + filterby
    );
    if (response == true || response == "true") {
      await common.rePopulateCities(this.country);
      this.cities = common.cities[this.country];
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (this.multiple === false || this.multiple != "") {
      if (newVal) {
        this.city = newVal;
        if (newVal.name) {
          this.$emit("input", newVal.name);
        }
        this.$emit("inputFull", newVal);
      } else {
        this.$emit("input", null);
        this.$emit("inputFull", null);
 
      }
    } else {
      const response = [];

      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i].name);
      }

      this.$emit("input", response);
    }
  }

  setValue() {
    // console.log(this.value);
    if (
      (this.value &&
        this.cities != null &&
        this.cities.length > 0 &&
        this.multiple != "") ||
      this.multiple === false
    ) {
      if (this.cities) {
        for (let i = 0; i < this.cities.length; i++) {
          if (this.cities[i].name === this.value) {
            this.city = this.cities[i];
            break;
          }
        }
      }
    } else if (this.cities != null && this.cities.length > 0) {
      this.city = [];
      if (this.value != null && this.value != "" && this.cities.length > 0) {
        for (let i = 0; i < this.cities.length; i++) {
          if (this.value.filter((e) => e === this.cities[i].name).length > 0) {
            this.city.push(this.cities[i]);
          }
        }
      }
    }
    this.loading = false;
  }

  async mounted() {
    this.loading = true;
    await common.populateCities(this.country);
    if (common.cities[this.country] == undefined)
      this.cities = common.cities[this.country];
    this.setValue();
    this.loading = false;
  }

  @Watch("country", { immediate: true })
  async onCountryChange(val) {
    this.filter = "";
    this.loading = true;
    this.cities = [];
    if (common.cities[val] == undefined) await common.populateCities(val);
    const cities = common.cities[this.country];
    if (cities != null && cities.length > 0) this.cities = cities;
    this.setValue();
  }

  @Watch("value", { immediate: true })
  async onValueChange() {
    this.filter = "";
    this.loading = true;
    this.cities = [];
    if (common.cities[this.country] == undefined)
      await common.populateCities(this.country);
    const cities = common.cities[this.country];
    if (cities != null && cities.length > 0) this.cities = cities;
    this.setValue();
  }

  @Watch("state", { immediate: true })
  async onStateChange(val) {
    this.filter = "";
    this.loading = true;
    this.cities = [];
    if (common.cities[val] == undefined) await common.populateCities(val);
    const cities = common.cities[this.country];
    if (cities != null && cities.length > 0) this.cities = cities;
    this.setValue();
  }

  selected(val) {
    if (val != null && val.name != null && this.city != null) {
      if (Array.isArray(this.city)) {
        for (let i = 0; i < this.city.length; i++) {
          if (val.name === this.city[i].name) {
            return true;
          }
        }
      } else if (this.city != null && this.city.name != undefined) {
        if (val.name === this.city.name) {
          return true;
        }
      }
    }
    return false;
  }

  remove(val) {
    if (val != null && val.name != null && this.city != null) {
      if (Array.isArray(this.city)) {
        for (let i = 0; i < this.city.length; i++) {
          if (val.name === this.city[i].name) {
            this.city.splice(i, 1);
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
